// Centralised brand assets. Update once → reflects everywhere.
// Using the original transparent-PNG logo so it blends seamlessly with any background.
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_b900a691-e276-4f55-b283-229aa9881e7a/artifacts/kduegc3q_furshala_logo_-removebg-preview.png";

// User-uploaded photography (Furshala-curated)
export const USER_PHOTOS = {
  dog_in_field: "https://customer-assets.emergentagent.com/job_paws-community-4/artifacts/yxvb34ve_pexels-edson-cuentas-583635811-17046862.jpg",
  cat_and_dog: "https://customer-assets.emergentagent.com/job_paws-community-4/artifacts/lx74qlkk_pexels-sayefotograf-29507137.jpg",
  dyed_fabric: "https://customer-assets.emergentagent.com/job_paws-community-4/artifacts/dr61ydk2_pexels-teona-swift-6851171.jpg",
  natural_dye_hands: "https://customer-assets.emergentagent.com/job_paws-community-4/artifacts/hxuev3pq_pexels-nhavan-34199683.jpg",
};

// Fallbacks (Unsplash) — only used when user hasn't set their own
export const STOCK_IMAGES = {
  hero: USER_PHOTOS.dog_in_field,
  event_card: "https://images.unsplash.com/photo-1450778869180-41d0601e046e?auto=format&fit=crop&w=1600&q=80",
  past_gallery: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?auto=format&fit=crop&w=1200&q=80",
};
